import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Layout from '@/components/Layout'
import Dashboard from '@/pages/Dashboard'
import CategoryPage from '@/pages/CategoryPage'
import ItemDetail from '@/pages/ItemDetail'
import Settings from '@/pages/Settings'
import OneDriveCallback from '@/pages/OneDriveCallback'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout><Dashboard /></Layout>} path="/" />
        <Route element={<Layout><CategoryPage category="vehicle" /></Layout>} path="/vehicles" />
        <Route element={<Layout><CategoryPage category="home" /></Layout>} path="/home" />
        <Route element={<Layout><CategoryPage category="property" /></Layout>} path="/property" />
        <Route element={<Layout><CategoryPage category="shares" /></Layout>} path="/shares" />
        <Route element={<Layout><CategoryPage category="tax" /></Layout>} path="/tax" />
        <Route element={<Layout><CategoryPage category="insurance" /></Layout>} path="/insurance" />
        <Route element={<Layout><CategoryPage category="other" /></Layout>} path="/other" />
        <Route element={<Layout><ItemDetail /></Layout>} path="/items/:id" />
        <Route element={<Layout><Settings /></Layout>} path="/settings" />
        <Route element={<OneDriveCallback />} path="/onedrive/callback" />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
